import React from "react";
import "./template.css";

const Faq = ({ data }) => {
  return (
    <div id="faq" className={"Center " + data.class}>
      {data.title && data.title.text && (
        <h1 className={data.title.class}>{data.title.text}</h1>
      )}
      {data.questions && data.questions.length > 0 && (
        <div className="questions">
          {data.questions.map(question => {
            return <Question question={question} />;
          })}
        </div>
      )}
    </div>
  );
};

const Question = ({ question }) => {
  let key = question.key ? `faq-${question.key}` : null;
  return (
    <div className="question-wrapper">
      <div className="question">
        <h1 className="question-icon medium-purple">Q</h1>
        <h1 id={key} className="purple-white small-title question-text">
          {question.question}
        </h1>
      </div>
      <div className={"answer"}>
        <h1 className="question-icon light-purple">A</h1>
        <div className={"answer-text"}>
          {question.answer.map(answer => {
            return <p className="white-text paragraph-text">{answer}</p>;
          })}
        </div>
      </div>
    </div>
  );
};

export default Faq;
